
import { DropdownItem } from '@/main/store/@types/dropdown.d';
import { PageMode } from '@/main/utils/pageMode';
import { Cell } from '@/main/utils/table';

export const dropdownList = {
	ReturnReasons: [] as DropdownItem[],
	PartReqReturnStatus: [] as DropdownItem[],
};

export const edit = {
	Id: null as number | null,
	RequestedFromId: null as number | null,
	CreatedDateTime: null as string | null,
	RequestStatusId: null as number | null,
	UpdatedById: null as number | null,
	LastUpdatedDateTime: null as string | null,
	OrderNo: null as number | null,
	OrderId: null as number | null,
	Remarks: null as string | null,
	ReturnReason: null as number | null,
	ReturnReasonText: null as string | null,
	ReturnQty: null as number | null,
	RejectedComments: null as string | null,
	OtherRemarks: null as string | null,
};

export const localState = {
	selectedNdRow: null as Cell[] | null,
};

export const props = {
	mode: null as PageMode | null,
	jfnd: {
		row: null as Cell[] | null,
		options: null as {} | null,
	},
	vyrobekndOzn: null as string | null,
	OrderId: null as number | null,
};
